import { apiSlice } from "../services/apiSlice";

export const accountApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        ChangePassword: builder.mutation({
            query: (data) => ({
                url: '/auth/change-password',
                method: 'POST',
                body: data
            }),
        }),
        GetFieldsData: builder.mutation({
            query: (data) => ({
                url: '/records/fields',
                method: 'PUT',
                body: data
            }),
        }),
        getLoginHistory: builder.query({
            query: (params) => ({
                url: '/me/login-history',
                method: 'GET',
                params
            }),
        }),

    }),
});

export const {
    useChangePasswordMutation,
    useGetFieldsDataMutation,
    useGetLoginHistoryQuery,
} = accountApiSlice;